import { Center, Flex, Icon, Text } from '@chakra-ui/react';
import { useMemo } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { BiMove } from 'react-icons/bi';

import { getColumns } from '../../Dashboard/DashboardWidget/widgetUtils';
import { getColumnLabel } from '../../utils/tableUtils';

export const ColumnOrder = ({
    widgetType,
    columnIds,
    setColumnIds,
}: {
    widgetType: DashboardWidgetType;
    columnIds: string[];
    setColumnIds: (values: string[]) => void;
}) => {
    const widgetTypeColumns = useMemo(() => getColumns(widgetType), [widgetType]);

    const moveColumn = (fromIdx: number, toIdx: number) => {
        const cols = [...columnIds];
        const [reorderedItem] = cols.splice(fromIdx, 1);
        cols.splice(toIdx, 0, reorderedItem);
        setColumnIds(cols);
    };

    return (
        <DragDropContext
            onDragEnd={(result) => {
                if (result.destination) {
                    moveColumn(result.source.index, result.destination.index);
                }
            }}
        >
            <Droppable droppableId="droppable">
                {(provided) => (
                    <div {...provided.droppableProps} ref={provided.innerRef}>
                        {columnIds.map((columnId, idx) => {
                            const col = widgetTypeColumns.find((colDef) => colDef.id === columnId);
                            if (!col) {
                                return null;
                            }
                            return (
                                <Draggable key={columnId} draggableId={columnId} index={idx}>
                                    {(prov) => (
                                        <Flex
                                            align="center"
                                            mb={1}
                                            px={2}
                                            py={1}
                                            borderWidth={1}
                                            borderRadius="md"
                                            justify="space-between"
                                            ref={prov.innerRef}
                                            {...prov.draggableProps}
                                        >
                                            <Flex gap={3} {...prov.dragHandleProps}>
                                                <Center>
                                                    <Icon as={BiMove} />
                                                </Center>
                                                <Text>
                                                    {typeof col.header === 'string'
                                                        ? col.header
                                                        : getColumnLabel(col.id!)}
                                                </Text>
                                            </Flex>
                                        </Flex>
                                    )}
                                </Draggable>
                            );
                        })}
                        {provided.placeholder as React.ReactNode}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );
};
